import React from 'react';
import { SongStatus } from '../../types';

interface StatusBadgeProps {
  status: SongStatus;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  const statusConfig = {
    live: {
      color: 'bg-green-500/20 text-green-400 border-green-500/30',
      label: 'Live',
      dot: 'bg-green-400'
    },
    pending: {
      color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
      label: 'Pending',
      dot: 'bg-yellow-400'
    },
    failed: {
      color: 'bg-red-500/20 text-red-400 border-red-500/30',
      label: 'Failed',
      dot: 'bg-red-400'
    },
    taken_down: {
      color: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
      label: 'Taken Down',
      dot: 'bg-gray-400'
    }
  };
  
  const config = statusConfig[status];
  
  return (
    <span
      className={`
        inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium
        border ${config.color} ${className}
      `}
    >
      <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${config.dot}`} />
      {config.label}
    </span>
  );
};